export default {_name:'Link.Decorated',module:'Field',view:'Element/Button/DecoratedLink',options:{color:'textPrimary',md:'auto',decorators:{link:true}}}